import { FormBuilder, Validators } from '@angular/forms';
import { MatSort, MatPaginator } from '@angular/material';
import { ObservableMedia } from '@angular/flex-layout';
import { first } from 'rxjs/operators/first';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';
import { combineLatest } from 'rxjs/observable/combineLatest';
import { DataTableSource } from '../../classes/DataTableSource/datatablesource';
import { ApplicationService } from '../../services/application/application.service';
import { AuthService } from '../../services/authentication/auth.service';
import { DialogService } from '../../services/dialogs/dialogs.service';
import { DownloadService, DownloadFormat, HttpMethod } from '../../services/download/download.service';
import { ErrorService } from '../../services/error/error.service';
import { SplashService } from '../../services/splash/splash.service';
import { UserService } from '../../services/user/user.service';
import { TitleCasePipe } from '../../pipes/titlecase.pipe';
import { validateEmail } from '../../validators/email.validator';
var ManageDesigneesComponent = /** @class */ (function () {
    function ManageDesigneesComponent(appService, authService, dialogService, downloadService, errorService, fb, mediaChange, splashService, titleCasePipe, userService) {
        this.appService = appService;
        this.authService = authService;
        this.dialogService = dialogService;
        this.downloadService = downloadService;
        this.errorService = errorService;
        this.fb = fb;
        this.mediaChange = mediaChange;
        this.splashService = splashService;
        this.titleCasePipe = titleCasePipe;
        this.userService = userService;
        this._subrelease = new Subject();
        this.AllHeaders = ['LastName', 'FirstName', 'SchoolName', 'RoleName', 'CanBypassAdmin', 'DesigneeActions'];
        this.AvailableRoles = [
            { RoleName: 'School Administrator', RoleID: 5, CanBypass: false },
            { RoleName: 'School Counselor', RoleID: 3, CanBypass: true },
        ];
        this.parentErrorStateMatcher = new ParentErrorStateMatcher();
    }
    Object.defineProperty(ManageDesigneesComponent.prototype, "NewUserRole", {
        get: function () {
            return (this.NewUserForm && this.NewUserForm.controls['Role']) || {};
        },
        enumerable: true,
        configurable: true
    });
    ManageDesigneesComponent.prototype.ngOnInit = function () {
        var self = this;
        self.AvailableSchools = null;
        self.DesigneesData = new DataTableSource([], self.paginator, self.sorter, self.SortDesignees.bind(self));
        self.Designees = null;
        self.FromSearch = false;
        self.NewUserForm = null;
        self.NoData = false;
        self.PartialViewReady = false;
        self.ShowingNewUserForm = false;
        self.SmallDisplay = false;
        self.User = null;
        self.SmallDisplay = self.mediaChange.isActive('xs') || self.mediaChange.isActive('sm');
        self.mediaChange
            .asObservable()
            .pipe(takeUntil(self._subrelease))
            .subscribe(function (media) {
            self.SmallDisplay = media.mqAlias === 'xs' || media.mqAlias === 'sm';
            self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
            self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
        });
        // Make an empty new user form
        self.NewUserForm = self.fb.group({
            FirstName: [null, Validators.required],
            LastName: [null, Validators.required],
            Email: [null, [Validators.required, validateEmail]],
            EmailVerify: [null, [Validators.required, validateEmail]],
            CanBypassAdmin: [false],
            UserID: [null],
            School: [null, Validators.required],
            Role: [null, Validators.required],
        }, { validator: [self.EmailVerifyValidator, self.NewDesigneeValidator.bind(self)] });
        // Get the first non-null UserInfo object so we can begin setting up the component
        self.userService.UserSubject.pipe(takeUntil(self._subrelease), first(function (user) { return user && !!user.AuthToken; })).subscribe(function (user) {
            self.User = user;
            // Set up constant monitoring of the user object, to catch AuthToken updates.
            self.userService.UserSubject.pipe(takeUntil(self._subrelease)).subscribe(function (_user) {
                self.User = _user;
            });
            // Load static data for use in the compoment.
            var schoolsObs = self.appService.GetAllSchools(self.User.AuthToken);
            var designeesObs = self.appService.GetAllDesignees(self.User.AuthToken, self.User.CurrentRole);
            combineLatest(schoolsObs, designeesObs, function (schools, designees) {
                return {
                    Schools: schools,
                    Designees: designees,
                };
            })
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (packet) {
                self.AvailableSchools = packet.Schools;
                self.Designees = packet.Designees;
                self.UpdateDesignees(packet.Designees);
                // Ready for component use.
                self.PartialViewReady = true;
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    ManageDesigneesComponent.prototype.ngOnDestroy = function () {
        this._subrelease.next();
        this._subrelease.complete();
    };
    // #region Add New Designee Method
    ManageDesigneesComponent.prototype.AddNewDesignee = function () {
        var self = this;
        var form = self.NewUserForm.getRawValue();
        // Get the user confirmation before proceeding.
        var message = "You are about to create the following new designee account in the system:<br /><br />\n<strong>First Name: </strong>" + self.titleCasePipe.transform(form.FirstName) + "<br />\n<strong>Last Name: </strong>" + self.titleCasePipe.transform(form.LastName) + "<br />\n<strong>Email Address: </strong>" + form.Email + "<br />\n<strong>School: </strong>" + form.School.SchoolName + "<br />\n<strong>Role: </strong>" + form.Role.RoleName + "<br />\n<strong>Can Bypass Admin: </strong>" + (form.CanBypassAdmin === true ? 'Yes' : 'No') + "<br /><br />\n" + (!self.FromSearch
            ? "<strong>This will create a new user account. Once the new user account is created, you will be given " +
                "the username and randomly generated password for the new account, and the user will be sent an " +
                "introduction email with directions on how to change their password and access the DELTA System.</strong>"
            : '') + "<br /><br />Are you sure you wish to add the new designee access as summarized above?";
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: "Yes - Add New Designee Account",
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (success) {
            if (success === true) {
                // Add new designee account
                self.splashService
                    .DisplaySplash({ TitleText: 'Please Wait', MessageText: 'Creating designee access...' })
                    .subscribe(function () {
                    self.authService
                        .AddNewUserAsDesignee(self.User.AuthToken, self.User.CurrentRole, form.UserID, form.FirstName, form.LastName, form.Email, form.School.SchoolNumber, form.Role.RoleID, form.CanBypassAdmin)
                        .subscribe(function (user) {
                        self.splashService.CloseSplash();
                        // Was the result returned a new account? If not, then the email address matched an existing
                        // one. Show a dialog in that case to the system user.
                        if (!user.NewAccount) {
                            // Show the dialog
                            self.dialogService.OpenMessageBoxDialog({
                                TitleText: 'Duplicate Email Address Detected',
                                MessageText: "The email address provided (" + form.Email + ") is already attached " +
                                    "to an existing account. The existing account information is provided below:" +
                                    ("<br /><br /><strong>Username: </strong>" + user.Username + "<br />") +
                                    ("<strong>User ID#: </strong>" + user.UserID + "<br />") +
                                    ("<strong>First Name: </strong>" + user.FirstName + "<br />") +
                                    ("<strong>Last Name: </strong>" + user.LastName + "<br />") +
                                    ("<strong>Email: </strong>" + user.Email + "<br /><br />You cannot create a new account ") +
                                    "using this email address. If the information above looks appropriate for the " +
                                    "desired user, you may provide them with the username shown above. Please note: " +
                                    "Designee access has NOT been granted at this time.",
                                OKText: 'OK',
                            });
                            var input = document.querySelector('.firstname');
                            input.focus();
                            return;
                        }
                        else {
                            // Reset and close the form
                            self.NewUserForm.reset();
                            self.ShowingNewUserForm = false;
                            // Update the listed designees with the returned packet (if available)
                            self.UpdateDesignees(user.Designees);
                            var msg2 = '';
                            var school = self.AvailableSchools.filter(function (item) {
                                return item.SchoolNumber === user.SchoolNumber;
                            });
                            if (self.FromSearch) {
                                // Display the created designee information
                                self.splashService.SnackbarSuccess('New Designee Access Created Successfully.');
                                msg2 =
                                    "The following designee account was created:<br /><br />\n                                        <strong>First Name: </strong>" + user.FirstName + "<br />\n                                        <strong>Last Name: </strong>" + user.LastName + "<br />\n                                        <strong>Email: </strong>" + user.Email + "<br />\n                                        <strong>School: </strong>" + (school && school.length ? school[0].SchoolName : '#' + user.SchoolNumber) + "<br />\n                                        <strong>Role: </strong>" + user.RoleName + "<br />\n                                        <strong>Can Bypass Admin: </strong>" + (user.CanBypassAdmin === true ? 'Yes' : 'No') + "<br /><br />This user has <strong>NOT</strong> been sent an email regarding their new " +
                                        "designee access rights. You will need to notify them as appropriate regarding " +
                                        "their new access.";
                            }
                            else {
                                self.splashService.SnackbarSuccess('New User Account & Designee Access Created Successfully.');
                                msg2 =
                                    "The following new user account was created:<br /><br />\n                                        <strong>Username: </strong>" + user.Username + "<br />\n                                        <strong>Password: </strong>" + user.Password + "<br />\n                                        <strong>Email: </strong>" + user.Email + "<br />\n                                        <strong>Polk User ID#: </strong>" + user.UserID + "<br />\n                                        <strong>School: </strong>" + (school && school.length ? school[0].SchoolName : '#' + user.SchoolNumber) + "<br />\n                                        <strong>Role: </strong>" + user.RoleName + "<br />\n                                        <strong>Can Bypass Admin: </strong>" + (user.CanBypassAdmin === true ? 'Yes' : 'No') + "<br /><br />This user <strong>HAS</strong> had an email sent to the provided email address " +
                                        "above with instructions on how to reset their default password and access the DELTA " +
                                        "System. However, the instructions do not mentioned designee access rights. " +
                                        "You will need to notify them as appropriate regarding their new access.";
                            }
                            self.dialogService
                                .OpenMessageBoxDialog({
                                TitleText: 'New Designee Account Information',
                                MessageText: msg2,
                                OKText: 'OK',
                            })
                                .subscribe();
                        }
                    }, function (error) {
                        self.errorService.HandleServiceError(error);
                    });
                });
            }
        });
    };
    // #endregion
    // #region Download Designees PDF Method
    ManageDesigneesComponent.prototype.DownloadDesigneesPDF = function () {
        var self = this;
        // Set splash
        self.splashService
            .DisplaySplash({ TitleText: 'Please wait', MessageText: 'Downloading Designees PDF...' })
            .pipe(takeUntil(self._subrelease))
            .subscribe(function () {
            self.downloadService
                .RetrieveDownload(HttpMethod.GET, "Api/Services/PDF/PDFDownloadDesigneesList", {
                AuthToken: self.User.AuthToken || '',
                CurrentRole: self.User.CurrentRole || '',
                Attachment: true,
            }, DownloadFormat.PDF)
                .pipe(takeUntil(self._subrelease))
                .subscribe(function (success) {
                // Drop the splash?
                self.splashService.CloseSplash();
            }, function (error) {
                self.errorService.HandleServiceError(error);
            });
        });
    };
    // #endregion
    // #region Email Verify Validate Method
    ManageDesigneesComponent.prototype.EmailVerifyValidator = function (grp) {
        var gval = grp.getRawValue();
        if (gval.Email !== gval.EmailVerify) {
            return {
                EmailVerifyValidate: 'mismatch',
            };
        }
        return null;
    };
    // #endregion
    // #region New Designee Validator Method
    ManageDesigneesComponent.prototype.NewDesigneeValidator = function (grp) {
        var self = this;
        var gval = grp.getRawValue();
        var good = true;
        if (!gval.FirstName) {
            good = false;
        }
        if (good && !gval.LastName) {
            good = false;
        }
        if (good && !gval.Email) {
            good = false;
        }
        if (good && !gval.EmailVerify) {
            good = false;
        }
        if (good && gval.UserID == null && self.FromSearch) {
            good = false;
        }
        if (good && !gval.School) {
            good = false;
        }
        if (good && !gval.Role) {
            good = false;
        }
        if (!good) {
            return {
                NewDesigneeValidate: 'required',
            };
        }
        return null;
    };
    // #endregion
    // #region Remove Designee Method
    ManageDesigneesComponent.prototype.RemoveDesignee = function (designee) {
        var self = this;
        if (!designee) {
            return;
        }
        var message = "You have chosen to remove the following user as a designee in the system:<br /><br />\n        <strong>First Name: </strong>" + self.titleCasePipe.transform(designee.FirstName) + "<br />\n        <strong>Last Name: </strong>" + self.titleCasePipe.transform(designee.LastName) + "<br />\n        <strong>School: </strong>" + designee.SchoolName + "<br />\n        <strong>Role: </strong>" + designee.RoleName + "<br />\n        <strong>Can Bypass Admin: </strong>" + (designee.CanBypassAdmin === true ? 'Yes' : 'No') + "<br /><br />\n        Once removed, this user must be added as a designee again in order to have access to student dual " +
            "enrollment records at this school. Are you sure you wish to continue?";
        // Get a confirmation
        self.dialogService
            .OpenConfirmationDialog({
            TitleText: 'Confirmation Requested',
            MessageText: message,
            OKText: 'Yes - Remove',
            CancelText: 'No - CANCEL',
        })
            .subscribe(function (result) {
            if (result === true) {
                // User has opted to proceed. Signal the system to remove this person as a designee.
                self.appService.RemoveDesignee(self.User.AuthToken, self.User.CurrentRole, designee.DesigneeID).subscribe(function (designees) {
                    // Completed. Refresh the list of designees from what was just returned.
                    self.UpdateDesignees(designees);
                    // Toast the success
                    self.splashService.SnackbarSuccess("User was removed as a designee successfully.");
                }, function (error) {
                    self.errorService.HandleServiceError(error);
                });
            }
        });
    };
    // #endregion
    // #region Reset New User Form Method
    ManageDesigneesComponent.prototype.ResetNewUserForm = function () {
        this.NewUserForm.reset();
        this.ShowingNewUserForm = false;
    };
    // #endregion
    // #region Show New User Form Method
    ManageDesigneesComponent.prototype.ShowNewUserForm = function () {
        this.ShowingNewUserForm = !this.ShowingNewUserForm;
    };
    // #endregion
    // #region Show User Search Method
    ManageDesigneesComponent.prototype.ShowUserSearch = function () {
        var self = this;
        // Pop up a user search dialog.
        self.dialogService
            .OpenUserSearchDialog({
            TitleText: 'DELTA User Search',
            MessageText: "Use the following options to search for an existing user in our district user database. " +
                "After a search is conducted, if no results are found or the desired new designee is not found, you can " +
                "create a new account for the designee by clicking the \"Create New Account\" button which will appear " +
                "at the bottom of this dialog:",
            DesigneeMode: true,
        })
            .subscribe(function (chosenUser) {
            if (chosenUser != null) {
                // Pre-fill in the new user form with the values returned from the user search just conducted, if a
                // user was selected. Otherwise, empty the form.
                if (chosenUser.User) {
                    var patchform = {
                        FirstName: chosenUser.User.FirstName,
                        LastName: chosenUser.User.LastName,
                        Email: chosenUser.User.Email,
                        EmailVerify: chosenUser.User.Email,
                        UserID: chosenUser.User.UserID,
                    };
                    // Patch the new user form.
                    self.NewUserForm.patchValue(patchform);
                    self.NewUserForm.controls['FirstName'].disable();
                    self.NewUserForm.controls['LastName'].disable();
                    self.NewUserForm.controls['Email'].disable();
                    self.NewUserForm.controls['EmailVerify'].disable();
                    self.NewUserForm.controls['UserID'].disable();
                    self.FromSearch = true;
                }
                else {
                    self.NewUserForm.reset();
                    self.NewUserForm.controls['FirstName'].enable();
                    self.NewUserForm.controls['LastName'].enable();
                    self.NewUserForm.controls['Email'].enable();
                    self.NewUserForm.controls['EmailVerify'].enable();
                    self.NewUserForm.controls['UserID'].enable();
                    self.FromSearch = false;
                }
                // Unlock the new entry panel for editing, but lock out the demographics.
                self.ShowingNewUserForm = true;
            }
        });
    };
    // #endregion
    // #region Sort Designees Method
    ManageDesigneesComponent.prototype.SortDesignees = function (First, Second) {
        var self = this;
        var PropA;
        var PropB;
        switch (self.sorter.active) {
            case 'LastName':
                _a = [First.LastName, Second.LastName], PropA = _a[0], PropB = _a[1];
                break;
            case 'FirstName':
                _b = [First.FirstName, Second.FirstName], PropA = _b[0], PropB = _b[1];
                break;
            case 'SchoolName':
                _c = [First.SchoolName, Second.SchoolName], PropA = _c[0], PropB = _c[1];
                break;
            case 'RoleName':
                _d = [First.RoleName, Second.RoleName], PropA = _d[0], PropB = _d[1];
                break;
            case 'CanBypassAdmin':
                _e = [First.CanBypassAdmin === true ? 1 : 0, Second.CanBypassAdmin === true ? 1 : 0], PropA = _e[0], PropB = _e[1];
                break;
        }
        var ValueA = PropA != null && PropA !== '' ? (isNaN(+PropA) ? PropA : +PropA) : PropA;
        var ValueB = PropB != null && PropB !== '' ? (isNaN(+PropB) ? PropB : +PropB) : PropB;
        return (ValueA < ValueB ? -1 : 1) * (self.sorter.direction === 'asc' ? 1 : -1);
        var _a, _b, _c, _d, _e;
    };
    // #endregion
    // #region Update Designees Method
    ManageDesigneesComponent.prototype.UpdateDesignees = function (designees) {
        var self = this;
        self.Designees = designees;
        if (!self.Designees || !self.Designees.length) {
            self.NoData = true;
            // Put in a fake record to trip the display message
            self.DesigneesData.Update([{}]);
        }
        else {
            self.NoData = false;
            self.DesigneesData.Update(self.Designees);
        }
        self.VisibleHeaders = self.SmallDisplay ? ['SmallDisplay'] : self.AllHeaders.slice();
        self.VisibleColumns = self.NoData ? ['NoData'] : self.VisibleHeaders.slice();
    };
    return ManageDesigneesComponent;
}());
export { ManageDesigneesComponent };
// #region Custom Classes
// #region New Designee User Info Class
var NewDesigneeUserInfo = /** @class */ (function () {
    function NewDesigneeUserInfo() {
    }
    return NewDesigneeUserInfo;
}());
export { NewDesigneeUserInfo };
// #endregion
// #region Parent Error State Matcher Class
var ParentErrorStateMatcher = /** @class */ (function () {
    function ParentErrorStateMatcher() {
    }
    ParentErrorStateMatcher.prototype.isErrorState = function (control, form) {
        var isSubmitted = !!(form && form.submitted);
        var controlTouched = !!(control && (control.dirty || control.touched));
        var controlInvalid = !!(control && control.invalid);
        var parentInvalid = !!(control &&
            control.parent &&
            control.parent.invalid &&
            (control.parent.dirty || control.parent.touched) &&
            control.parent.hasError('EmailVerifyValidate'));
        return isSubmitted || (controlTouched && (controlInvalid || parentInvalid));
    };
    return ParentErrorStateMatcher;
}());
export { ParentErrorStateMatcher };
// #endregion
// #endregion



// WEBPACK FOOTER //
// ./src/app/managedesignees/managedesignees.component.ts.pre-build-optimizer.js